<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { ButtonV2 } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import NoResults from './NoResults.svelte';

	const dispatch = createEventDispatcher<{ retry: void }>();
</script>

<NoResults
	noResultsFound={{
		icon: 'fa-light fa-triangle-exclamation',
		title: $format('recordings_list_load_error', { default: "Couldn't load recordings" }),
		description: $format('recordings_list_load_error_description', {
			default: 'Something went wrong. Please try again.',
		}),
	}}
/>
<div class="d-flex justify-content-center mt-m">
	<ButtonV2 variant="secondary" size="m" on:click={() => dispatch('retry')}>
		{capFirstChar($format('button_try_again', { default: 'Try again' }))}
	</ButtonV2>
</div>
